import { useCallback } from 'react';
import { CAR_TARGET } from '~/data/consts';

type CarType = (typeof CAR_TARGET)[keyof typeof CAR_TARGET] | string;

interface CarFields {
  manufacturer: string;
  model: string;
  finishLevel?: string;
  color?: string;
  price?: string;
  year?: string;
  mileage?: string;
  carNumber?: string;
  isCarZeroKm?: boolean;
}

export const useCarDetailsNote = () => {
  const getCarDetailsNote = useCallback(
    (carType: CarType, fields: CarFields): string => {
      const filterEmpty = (arr: (string | number)[]) => {
        return arr.filter(Boolean).join(' | ');
      };

      switch (carType) {
        case CAR_TARGET.NEW_CAR:
          return filterEmpty([
            `${fields.manufacturer} ${fields.model}`,
            fields.finishLevel ?? '',
            fields.color ?? '',
            fields.price ?? '',
            fields.isCarZeroKm ? '0 ק"מ' : '',
          ]).trim();

        case CAR_TARGET.LEASING:
          return filterEmpty([
            `${fields.manufacturer} ${fields.model}`,
            fields.finishLevel ?? '',
            fields.color ?? '',
            fields.price ?? '',
          ]).trim();

        case CAR_TARGET.USED_CAR:
          return filterEmpty([
            `${fields.manufacturer} ${fields.model} ${fields.year ?? ''}`,
            `${fields.mileage ?? ''} ק"מ`,
            fields.carNumber ?? '',
          ]).trim();

        default:
          return '';
      }
    },
    [],
  );

  return { getCarDetailsNote };
};
